var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-box"},[_c('span',{staticClass:"arrow-container pointer",on:{"click":function($event){return _vm.pageTurning($event)}}},[_c('i',{staticClass:"iconfont icon-xialajiantouxiao"})])])}
var staticRenderFns = []

export { render, staticRenderFns }